var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10812"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 14.625C15.0355 14.625 15.875 13.7855 15.875 12.75C15.875 11.7145 15.0355 10.875 14 10.875C12.9645 10.875 12.125 11.7145 12.125 12.75C12.125 13.7855 12.9645 14.625 14 14.625Z",
    stroke: "#A2A2A2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 7.75C12.6739 7.75 11.4021 8.27678 10.4645 9.21447C9.52678 10.1521 9 11.4239 9 12.75C9 13.9325 9.25125 14.7062 9.9375 15.5625L14 20.25L18.0625 15.5625C18.7488 14.7062 19 13.9325 19 12.75C19 11.4239 18.4732 10.1521 17.5355 9.21447C16.5979 8.27678 15.3261 7.75 14 7.75Z",
    stroke: "#A2A2A2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/place_icon.d3c253d91e248820f46313e04d019196.svg";
export { ForwardRef as ReactComponent };